// extracted by mini-css-extract-plugin
module.exports = {"formitemRow":"sendProductTable_formitemRow__3MeAU"};